import { IAuthService } from './interfaces'
import { LoginUseCase, LogoutUseCase } from '../useCases/AuthenticationUseCases'
import { LoginUseCaseRequest, LoginUseCaseResponse } from '../useCases/interfaces'
import { Result } from '@/shared/utils/Result'

export class AuthService implements IAuthService {
  constructor(
    private readonly loginUseCase: LoginUseCase,
    private readonly logoutUseCase: LogoutUseCase,
  ) {}

  async login(request: LoginUseCaseRequest): Promise<Result<LoginUseCaseResponse, Error>> {
    return await this.loginUseCase.execute(request)
  }

  async logout(userId: string): Promise<Result<void, Error>> {
    return await this.logoutUseCase.execute({ userId })
  }
}